import { useCallback, useEffect, useRef, useState } from 'react';
import useBimZoom from '../../hooks/useBimZoom';
// import { Tooltip } from 'library/tooltip';
import { ICameraBimModel, ICameraImage } from '@api/models';
import useLoading from '@hooks/use-loading';
import { Button, IconButton } from '@hyperflake/react-ui-library';
import { CalendarIcon, CrossIcon, LockIcon, SlidersIcon, UnlockIcon } from '@icon/index';
// import { Tooltip } from '@library/tooltip';
import { saveCameraBim, uploadBimScheduling } from '@api/services/camera.service';
import { AutodeskForgeViewer, AutodeskForgeViewerRef, ForgeViewer, SchedulePlaningTool } from '@library/forge-viewer';
import { CircularProgress } from '@library/loaders/components';
import { Popover } from '@library/popover';
import { Tooltip } from '@library/tooltip';
import { useMutation } from '@tanstack/react-query';
import BlurBackgroundImage from 'modules/reseller-cameras/components/ui/BlurBackgroundImage';
import OverlayLoader from 'modules/reseller-cameras/components/ui/OverlayLoader';
import ContentViewer from 'modules/shared/features/ContentViewer/ContentViewer';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { normalizeToCsvFile } from '../../helpers/parse-scheduling-file.utils';

const OriginalDevicePixelRatio = window.devicePixelRatio;
const MULTIPLIER = 2.5;
const TOOLS = ['measure', 'calibration'];
type UiBimScheduleMapping = {
    activityCode: string;
    activityName: string;
    earlyStartDate: string;
    earlyEndDate: string;
    file?: globalThis.File;
};

interface CameraBimViewerProps {
    images: ICameraImage[];
    selectedImage: ICameraImage;
    onSelectedImageChange: (image: ICameraImage) => void;
    // selectedDate: string;
    onSelectedDateChange: (date: string) => void;
    startDate: string;
    endDate: string;
    isLoading: boolean;
    bimDetails: ICameraBimModel;
    schedulingData?: { earlyStartDate: Date; earlyEndDate: Date; activityCode: string; activityName: string }[];
}
const CameraBimViewer = (props: CameraBimViewerProps) => {
    const {
        images,
        selectedImage,
        onSelectedImageChange,
        // selectedDate,
        onSelectedDateChange,
        startDate,
        endDate,
        isLoading,
        bimDetails,
        schedulingData,
    } = props;

    // const { user } = useAuthSelector();

    const { clientId, projectId, cameraId } = useParams();

    const imageUrl = selectedImage.urlPreview;
    // const imageUrl = useMemo(() => getPreferedImageUrl(user, selectedImage), [user, selectedImage]);

    const [imgLoading, setImgLoading] = useLoading(imageUrl);
    const [showOpacityRange, setShowOpacityRange] = useState<boolean>(false);
    const [navigationLock, setNavigationLock] = useState<boolean>(true);
    const [showSavePopover, setShowSavePopover] = useState<boolean>(false);
    const [isUpdatePopoverOpen, setIsUpdatePopoverOpen] = useState(false);
    const [scheduleMapping, setScheduleMapping] = useState<UiBimScheduleMapping>({
        activityCode: '',
        activityName: '',
        earlyStartDate: '',
        earlyEndDate: '',
        file: undefined,
    });
    const [schedulingFile, setSchedulingFile] = useState<File | null>(null);
    const modelStructurePanelRef = useRef<HTMLDivElement>(null);
    const toolbarRef = useRef<HTMLDivElement>(null);
    const calibrationPanelRef = useRef<HTMLDivElement>(null);
    const forgeViewerRef = useRef<AutodeskForgeViewerRef>(null);

    const schedulingToolRef = useRef<SchedulePlaningTool>(null);
    // const imageViewingToolRef = useRef<ImageViewingTool>(new ImageViewingTool());
    const [activityDbIdMap, setActivityDbIdMap] = useState<Map<string, number[]>>(new Map());
    const [dateRange, setDateRange] = useState<{ min: Date; max: Date }>({ min: null, max: null });
    const [isSchedulingDataReady, setIsSchedulingDataReady] = useState(true);
    const [isToolActive, setIsToolActive] = useState<boolean>(false);
    const [isBimLoading, setIsBimLoading] = useState<boolean>(true);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const sliderMin = dateRange.min ? dateToSliderValue(dateRange.min) : 0;
    const sliderMax = dateRange.max ? dateToSliderValue(dateRange.max) : 0;

    // fallback value: use min if selectedDate is not set yet
    const sliderValue = selectedDate ? dateToSliderValue(selectedDate) : sliderMin;
    const [isDataReady, setIsDataReady] = useState(false);
    const [showScheduling, setShowScheduling] = useState<boolean>(false);

    // const { text } = useLoadingText({
    //     messages: ['Getting everything ready...', 'Putting everything together...', 'Almost there...'],
    //     delay: 2000,
    // });

    // const canvasWrapRef = useRef(null);
    useEffect(() => {
        console.log('schedulingData', schedulingData);
        if (!schedulingData) {
            setIsDataReady(true);
            return;
        }

        setIsDataReady(false);

        schedulingToolRef.current = new SchedulePlaningTool(schedulingData);
    }, [schedulingData]);

    // useEffect(() => {
    //     // if (!selectedDate) return;

    //     // if (activityDbIdMap.size === 0) return;

    //     schedulingToolRef.current.updateVisibility(moment(selectedDate, 'YYYYMMDD').toDate(), activityDbIdMap);
    // }, [activityDbIdMap, selectedDate]);

    const [state, setState] = useState({ x: 0, y: 0, k: 1 });

    const { refs: zoomRefs } = useBimZoom({
        state,
        setState,
    });

    const [showImageSlider, setShowImageSlider] = useState<boolean>(false);
    const [opacityValue, setOpacityValue] = useState<Number>(0.6);

    const cameraBimMutation = useMutation((payload: any) => saveCameraBim(clientId, projectId, cameraId, payload));

    const handleSaveBim = async () => {
        if (!forgeViewerRef.current) return;
        const viewport = forgeViewerRef.current.instance.camera.getState({ viewport: true });

        try {
            await cameraBimMutation.mutateAsync(viewport);

            setShowSavePopover(false);

            toast.success('Bim updated successfully.');
        } catch (err: any) {
            toast.error(err.data.message || 'Something went wrong.');
        }
    };

    // const handleRangeUpdate = useCallback(
    //     (date: Date | null) => {
    //         // keep UI state in sync
    //         setSelectedDate(date);

    //         // guards
    //         if (!date) return;
    //         if (!schedulingToolRef.current) return;
    //         if (!activityDbIdMap || activityDbIdMap.size === 0) return;
    //         if (!isSchedulingDataReady) return;
    //         console.log('date in handle range', date);

    //         // core behavior: update what’s visible in the model for this date
    //         schedulingToolRef.current.updateVisibility(date, activityDbIdMap);
    //     },
    //     [activityDbIdMap, isSchedulingDataReady]
    // );
    // const dbg = (...args: any[]) => console.log('[BIM:SCHED]', ...args);

    // const handleRangeUpdate = useCallback(
    //     (date: Date | null) => {
    //         dbg('handleRangeUpdate called', { date });

    //         setSelectedDate(date);

    //         if (!date) return dbg('EXIT: date is null');
    //         if (!schedulingToolRef.current) return dbg('EXIT: schedulingToolRef.current is null');
    //         if (!activityDbIdMap) return dbg('EXIT: activityDbIdMap is null/undefined');
    //         if (activityDbIdMap.size === 0) return dbg('EXIT: activityDbIdMap.size === 0');
    //         if (!isSchedulingDataReady) return dbg('EXIT: isSchedulingDataReady is false');

    //         dbg('CALL: updateVisibility', {
    //             date: date.toISOString(),
    //             mapSize: activityDbIdMap.size,
    //             tool: schedulingToolRef.current,
    //         });

    //         schedulingToolRef.current.updateVisibility(date, activityDbIdMap);

    //         dbg('DONE: updateVisibility returned');
    //     },
    //     [activityDbIdMap, isSchedulingDataReady]
    // );

    const handleRangeUpdate = useCallback(
        (date: Date | null) => {
            // keep UI state in sync
            setSelectedDate(date);

            // guards
            if (!date) return;
            if (!schedulingToolRef.current) return;
            if (!activityDbIdMap || activityDbIdMap.size === 0) return;
            if (!isSchedulingDataReady) return;

            // core behavior: update what’s visible in the model for this date
            schedulingToolRef.current.updateVisibility(date, activityDbIdMap);
        },
        [activityDbIdMap, isSchedulingDataReady]
    );

    const uploadMutation = useMutation({
        mutationFn: (formData: FormData) => uploadBimScheduling(clientId, projectId, cameraId, formData),
    });
    const buildSchedulingFormData = async (data: UiBimScheduleMapping) => {
        const formData = new FormData();

        // columnMapping (flattened, NOT stringified)
        formData.append('columnMapping[activityCode]', data.activityCode);
        formData.append('columnMapping[activityName]', data.activityName);
        formData.append('columnMapping[earlyStartDate]', data.earlyStartDate);
        formData.append('columnMapping[earlyEndDate]', data.earlyEndDate);

        // file (binary)
        if (data.file) {
            const csvFile = await normalizeToCsvFile(data.file);
            formData.append('file', csvFile, csvFile.name);
        }

        return formData;
    };

    const handleSchedulingSave = async () => {
        try {
            // basic validation (optional)
            if (!scheduleMapping.file) {
                toast.error('Please select a scheduling file.');
                return;
            }

            const formData = await buildSchedulingFormData(scheduleMapping);
            console.log('formData', formData);

            await uploadMutation.mutateAsync(formData);

            toast.success('Scheduling uploaded successfully.');
            setIsUpdatePopoverOpen(false);

            // optional: reset form
            setScheduleMapping({
                activityCode: '',
                activityName: '',
                earlyStartDate: '',
                earlyEndDate: '',
                file: undefined,
            });
        } catch (err: any) {
            toast.error(err?.message || 'Something went wrong.');
        }
    };

    const moveToolbar = useCallback(() => {
        const observer = new MutationObserver(() => {
            const el = document.querySelector('#guiviewer3d-toolbar') as HTMLDivElement;

            const host = toolbarRef.current;

            if (!el || !host) return;

            // prevent re-adding if already moved
            if (host.contains(el)) return;

            host.appendChild(el);
        });

        // Observe DOM changes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }, []);

    const moveModelStructurePanel = useCallback(() => {
        const observer = new MutationObserver(() => {
            const el = document.querySelector('#ViewerModelStructurePanel') as HTMLDivElement;

            const host = modelStructurePanelRef.current;

            if (!el || !host) return;

            // prevent re-adding if already moved
            if (host.contains(el)) return;

            host.appendChild(el);
        });

        // Observe DOM changes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }, []);

    const moveCalibrationPanel = useCallback(() => {
        const observer = new MutationObserver(() => {
            const el = document.querySelector('#calibration-panel') as HTMLDivElement;

            const host = calibrationPanelRef.current;

            if (!el || !host) return;

            // prevent re-adding if already moved
            if (host.contains(el)) return;

            host.appendChild(el);
        });

        // Observe DOM changes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }, []);

    const handleModelLoaded = useCallback((viewer: ForgeViewer) => {
        if (import.meta.env.VITE_APP_ENVIRONMENT === 'staging') {
            (global as any).viewer = viewer;
        }

        window.devicePixelRatio = OriginalDevicePixelRatio * MULTIPLIER;

        viewer.instance.setQualityLevel(false, false);
        viewer.instance.setGroundShadow(false);
        viewer.instance.setGroundReflection(false);
        viewer.instance.setProgressiveRendering(true);
        viewer.instance.setEnvMapBackground(false);

        // viewer.instance.toolbar.setVisible(false);
    }, []);

    const hideTools = useCallback((toolbar: Autodesk.Viewing.UI.ControlGroup, tools: string[]) => {
        if (toolbar) {
            tools.forEach((tool) => {
                toolbar.removeControl(tool);
            });
        }
    }, []);

    const hideNavTools = useCallback(
        (viewer: ForgeViewer) => {
            const toolbar = viewer.instance.toolbar.getControl('navTools') as Autodesk.Viewing.UI.ControlGroup;
            const tools = [
                'toolbar-orbitTools',
                'toolbar-panTool',
                'toolbar-bimWalkTool',
                'toolbar-cameraSubmenuTool',
                'toolbar-zoomTool',
            ];

            hideTools(toolbar, tools);
        },
        [hideTools]
    );

    const hideSettingsTools = useCallback(
        (viewer: ForgeViewer) => {
            const toolbar = viewer.instance.toolbar.getControl('settingsTools') as Autodesk.Viewing.UI.ControlGroup;
            const tools = ['toolbar-settingsTool', 'toolbar-fullscreenTool', 'toolbar-propertiesTool'];

            hideTools(toolbar, tools);
        },
        [hideTools]
    );

    const hideModelTools = useCallback(
        (viewer: ForgeViewer) => {
            const toolbar = viewer.instance.toolbar.getControl('modelTools') as Autodesk.Viewing.UI.ControlGroup;
            const tools = ['toolbar-sectionTool'];

            hideTools(toolbar, tools);
        },
        [hideTools]
    );

    const contructSchedulingData = useCallback(async () => {
        console.log('inn construct');
        const activityMap = await schedulingToolRef.current.getActivityDbIdsMap();
        setIsDataReady(true);
        console.log('activityMapt', activityMap);
        const dateRange = schedulingToolRef.current.calculateDateRange();

        setActivityDbIdMap(activityMap);
        setDateRange(dateRange);

        setIsSchedulingDataReady(true);
    }, []);

    const handleObjectTreeCreated = useCallback(
        (viewer: ForgeViewer) => {
            viewer.camera.restoreState(bimDetails.state);
            viewer.camera.setCurrentViewAsHome();
            // viewer.instance.toolbar.setVisible(false);

            moveToolbar();
            moveModelStructurePanel();
            moveCalibrationPanel();
            viewer.instance.toolbar.setVisible(false);

            // imageViewingToolRef.current.attach(viewer);

            // Hide loading screen after 1 second of object tree created
            setTimeout(() => {
                setIsBimLoading(false);
            }, 1000);
        },
        [bimDetails.state, moveCalibrationPanel, moveModelStructurePanel, moveToolbar]
    );

    const handleGeometryLoaded = useCallback(
        async (viewer: ForgeViewer) => {
            // hideNavTools(viewer);
            // hideSettingsTools(viewer);
            // hideModelTools(viewer);

            // viewer.instance.toolbar.setVisible(true);

            if (schedulingData) {
                schedulingToolRef.current.attach(viewer);
                await contructSchedulingData();
            }
        },
        [contructSchedulingData, hideModelTools, hideNavTools, hideSettingsTools, schedulingData]
    );

    const handleToolChange = useCallback((_: ForgeViewer, e: any) => {
        if (TOOLS.includes(e.toolName)) {
            setIsToolActive(e.active);
        }
    }, []);

    // const handleViewerResize = useCallback(() => {
    //     window.devicePixelRatio = OriginalDevicePixelRatio;
    // }, []);

    // useEffect(() => {
    //     if (!forgeViewerRef.current) return;
    //     forgeViewerRef.current.instance.instance.toolbar.setVisible(navigationLock);
    // }, []);
    const handleNavigationLock = useCallback(() => {
        if (!forgeViewerRef.current) return;
        setNavigationLock(!navigationLock);
        forgeViewerRef.current.instance.instance.toolbar.setVisible(navigationLock);
    }, [navigationLock]);

    function dateToSliderValue(date: Date): number {
        return date?.getTime();
    }

    function sliderValueToDate(value: number): Date {
        return new Date(value);
    }

    // const handleSliderChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = parseInt(e.target.value, 10);
    //     console.log('value inn slider', value);
    //     setSelectedDate(sliderValueToDate(value));
    // }, []);
    const handleSliderChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = parseInt(e.target.value, 10);
            const date = sliderValueToDate(value);
            handleRangeUpdate(date);
        },
        [handleRangeUpdate]
    );

    // useEffect(() => {
    //     if (!dateRange?.min) return;
    //     if (selectedDate) return;
    //     handleRangeUpdate(dateRange.min);
    // }, [dateRange.min, selectedDate, handleRangeUpdate]);
    useEffect(() => {
        if (!schedulingData) return;
        if (!schedulingToolRef.current) return;
        if (!activityDbIdMap || activityDbIdMap.size === 0) return;

        if (!showScheduling) {
            // show everything when scheduling is OFF
            schedulingToolRef.current.updateVisibility(
                new Date('2100-01-01'), // or implement tool.resetVisibility()
                activityDbIdMap
            );
            return;
        }

        // when toggling back ON, apply current slider date (or min)
        const date = selectedDate ?? dateRange.min;
        if (date) schedulingToolRef.current.updateVisibility(date, activityDbIdMap);
    }, [showScheduling, schedulingData, activityDbIdMap, selectedDate, dateRange.min]);

    return (
        <>
            <ContentViewer className="h-full">
                <div className="relative overflow-hidden">
                    <div className="relative">
                        <BlurBackgroundImage src={imageUrl}>
                            <div className="relative">
                                <div
                                    ref={zoomRefs.container.setReference}
                                    className="relative h-[calc(100vh-var(--header-height)-var(--image-slider-height))] md:h-[calc(100vh-var(--header-height))]"
                                >
                                    <div
                                        className="relative max-h-full"
                                        ref={zoomRefs.content.setReference}
                                        style={{
                                            aspectRatio:
                                                selectedImage?.resolution.width / selectedImage?.resolution.height,
                                        }}
                                    >
                                        <img
                                            className="w-full h-full"
                                            src={imageUrl}
                                            // src="/dummy-assets/20231022230000.jpg"
                                            alt=""
                                            onLoad={() => setImgLoading(false)}
                                            // style={{ opacity: 0.4, pointerEvents: 'none' }}
                                        />

                                        <div
                                            className="absolute inset-0 z-[1]"
                                            style={{
                                                pointerEvents: navigationLock ? 'none' : 'all',
                                                // pointerEvents: isToolActive ? 'all' : 'none',
                                                opacity: +opacityValue,
                                            }}
                                        >
                                            <AutodeskForgeViewer
                                                ref={forgeViewerRef}
                                                accessToken={bimDetails.accessToken}
                                                urn={bimDetails.urn}
                                                onObjectTreeCreated={handleObjectTreeCreated}
                                                onModelLoaded={handleModelLoaded}
                                                onGeometryLoaded={handleGeometryLoaded}
                                                // onTexturesLoaded={handleGeometryLoaded}
                                                onToolChange={handleToolChange}
                                                // onExtensionActivated={handleExtensionActivated}
                                                // onExtensionDeactivated={handleExtensionDeactivated}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </BlurBackgroundImage>
                        {/* {!isDataReady && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    left: '20px',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    padding: '3px 8px',
                                    borderRadius: '999px',
                                    color: 'white',
                                    fontSize: '11px',
                                    zIndex: 9,
                                }}
                            >
                                Loading schedule data…
                            </div>
                        )} */}

                        {showScheduling && (
                            <div
                                style={{
                                    position: 'absolute',
                                    bottom: '20px',
                                    left: '20px',
                                    right: '20px',
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    padding: '16px',
                                    borderRadius: '8px',
                                    color: 'white',
                                    zIndex: 9,
                                }}
                            >
                                <input
                                    type="range"
                                    min={sliderMin}
                                    max={sliderMax}
                                    value={sliderValue}
                                    onChange={handleSliderChange}
                                    disabled={!dateRange.min || !dateRange.max || !isSchedulingDataReady}
                                    style={{ width: '100%', cursor: 'pointer' }}
                                />
                            </div>
                        )}

                        <div className="adsk-viewing-viewer dark-theme">
                            <div ref={toolbarRef}></div>
                        </div>

                        <div className="absolute top-0 left-0">
                            <div ref={modelStructurePanelRef} className="adsk-viewing-viewer dark-theme"></div>
                        </div>

                        <div className="absolute top-0 left-0">
                            <div ref={calibrationPanelRef} className="adsk-viewing-viewer dark-theme"></div>
                        </div>

                        <OverlayLoader show={imgLoading} />

                        {/* <OverlayLoader show={isBimLoading}>
                            <div className="text-sm text-grayscale-900 font-medium">{text}</div>
                        </OverlayLoader> */}

                        {!imageUrl && (
                            <div className="absolute inset-0 flex items-center justify-center bg-background-color text-grayscale-500 font-medium z-[2]">
                                No image on this date
                            </div>
                        )}
                    </div>

                    <ContentViewer.Floating position="top-left">
                        <div className="flex flex-col items-start gap-4">
                            <Popover
                                className=""
                                placement="bottom-start"
                                contentClassName="px-6 py-5 rounded-2xl shadow-lg w-[380px]"
                                open={showSavePopover}
                                setOpen={setShowSavePopover}
                                content={
                                    <div>
                                        <p className="text-sm text-grayscale-500">
                                            Are you sure you want to save this change?
                                        </p>

                                        <div className="flex gap-3 mt-4">
                                            <Button
                                                disabled={cameraBimMutation.isLoading}
                                                size="xs"
                                                color="primary"
                                                onClick={handleSaveBim}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                onClick={() => setShowSavePopover(false)}
                                                size="xs"
                                                variant="shaded"
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                }
                            >
                                {!isBimLoading && <Button className="text-grayscale-600 bg-white">save</Button>}
                            </Popover>
                            {!isBimLoading && (
                                <Popover
                                    placement="bottom-start"
                                    open={isUpdatePopoverOpen}
                                    setOpen={setIsUpdatePopoverOpen}
                                    contentClassName="px-4 py-3 rounded-2xl shadow-lg bg-white w-80 mt-4"
                                    content={
                                        <div>
                                            {/* Header */}
                                            <div className="flex justify-between items-center mb-4">
                                                <div className="text-sm text-grayscale-600 font-medium">
                                                    Upload Scheduling
                                                </div>
                                                <button onClick={() => setIsUpdatePopoverOpen(false)}>
                                                    <CrossIcon className="w-3 h-3" />
                                                </button>
                                            </div>

                                            {/* Form */}
                                            <div className="flex flex-col gap-3">
                                                {/* File */}
                                                <div>
                                                    <label className="text-xs text-grayscale-500 mb-1 block">
                                                        Scheduling File (CSV / Excel)
                                                    </label>

                                                    <input
                                                        type="file"
                                                        accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                                        onChange={(e) => {
                                                            const file = e.target.files?.[0];
                                                            setScheduleMapping((p) => ({ ...p, file }));
                                                        }}
                                                    />

                                                    {scheduleMapping.file ? (
                                                        <div className="mt-1 text-xs text-grayscale-500">
                                                            Selected: {scheduleMapping.file.name}
                                                        </div>
                                                    ) : null}
                                                </div>

                                                {/* Activity Code */}
                                                <div>
                                                    <label className="text-xs text-grayscale-500 mb-1 block">
                                                        Activity Code
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={scheduleMapping.activityCode}
                                                        onChange={(e) =>
                                                            setScheduleMapping((p) => ({
                                                                ...p,
                                                                activityCode: e.target.value,
                                                            }))
                                                        }
                                                        className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                                                        placeholder="Enter activity code"
                                                    />
                                                </div>

                                                {/* Activity Name */}
                                                <div>
                                                    <label className="text-xs text-grayscale-500 mb-1 block">
                                                        Activity Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={scheduleMapping.activityName}
                                                        onChange={(e) =>
                                                            setScheduleMapping((p) => ({
                                                                ...p,
                                                                activityName: e.target.value,
                                                            }))
                                                        }
                                                        className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                                                        placeholder="Enter activity name"
                                                    />
                                                </div>

                                                {/* Early Start Date */}
                                                <div>
                                                    <label className="text-xs text-grayscale-500 mb-1 block">
                                                        Early Start Date
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={scheduleMapping.earlyStartDate}
                                                        onChange={(e) =>
                                                            setScheduleMapping((p) => ({
                                                                ...p,
                                                                earlyStartDate: e.target.value,
                                                            }))
                                                        }
                                                        placeholder="Enter early start date"
                                                        className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                                                    />
                                                </div>

                                                {/* Early End Date */}
                                                <div>
                                                    <label className="text-xs text-grayscale-500 mb-1 block">
                                                        Early End Date
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={scheduleMapping.earlyEndDate}
                                                        onChange={(e) =>
                                                            setScheduleMapping((p) => ({
                                                                ...p,
                                                                earlyEndDate: e.target.value,
                                                            }))
                                                        }
                                                        placeholder="Enter early end date"
                                                        className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                                                    />
                                                </div>
                                            </div>

                                            {/* Actions */}
                                            <div className="flex items-center gap-2 mt-4">
                                                <Button
                                                    size="xs"
                                                    color="primary"
                                                    onClick={handleSchedulingSave}
                                                    // disabled={uploadMutation.isLoading}
                                                >
                                                    {/* {uploadMutation.isLoading ? 'Saving...' : 'Save'} */}
                                                    Save
                                                </Button>
                                            </div>
                                        </div>
                                    }
                                >
                                    <Tooltip placement="left" content="Upload Scheduling file">
                                        <Button className="text-grayscale-600 bg-white">
                                            {/* <UploadIcon width={18} height={18} className="text-grayscale-600" /> */}
                                            Upload
                                        </Button>
                                    </Tooltip>
                                </Popover>
                            )}
                        </div>
                    </ContentViewer.Floating>

                    <ContentViewer.Floating position="top-right">
                        <div className="relative">
                            {!isBimLoading && (
                                <Tooltip placement="left" content={'Change Opacity'} contentClassName="">
                                    <IconButton
                                        className="bg-white border-b-2"
                                        onClick={() => setShowOpacityRange(!showOpacityRange)}
                                    >
                                        <SlidersIcon width={18} height={22} className="text-grayscale-600" />
                                    </IconButton>
                                </Tooltip>
                            )}

                            {!isBimLoading && (
                                <Tooltip placement="left" content={'Navigation Lock'} contentClassName="max-w-sm ">
                                    <IconButton
                                        className="bg-white border-b-2 mt-4"
                                        onClick={() => handleNavigationLock()}
                                    >
                                        {navigationLock ? (
                                            <LockIcon width={18} height={22} className="text-grayscale-600" />
                                        ) : (
                                            <UnlockIcon width={18} height={22} className="text-grayscale-600" />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            )}

                            {!isBimLoading && isDataReady ? (
                                <Tooltip
                                    placement="left"
                                    content={showScheduling ? 'Hide Scheduling' : 'Show Scheduling'}
                                >
                                    <IconButton
                                        className={`${showScheduling ? 'bg-red-400' : 'bg-white'}  mt-4`}
                                        onClick={() => setShowScheduling((v) => !v)}
                                    >
                                        {/* Replace this with CalendarIcon / TimelineIcon */}
                                        <CalendarIcon width={18} height={18} className="text-grayscale-600" />
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <Tooltip placement="left" content={'Loading schedule data…'}>
                                    <IconButton
                                        className={`bg-white border-b-2 mt-4`}
                                        // onClick={() => setShowScheduling((v) => !v)}
                                    >
                                        {/* Replace this with CalendarIcon / TimelineIcon */}
                                        {/* <CalendarIcon width={18} height={18} className="text-grayscale-600" /> */}
                                        <CircularProgress size={20} />
                                    </IconButton>
                                </Tooltip>
                            )}

                            {showOpacityRange && (
                                <div className="absolute right-0 cursor-pointer pt-[0.5rem] pb-[0.3rem] px-4 rounded-md bg-white shadow-[0px_0px_2px_rgba(18,40,44,0.12),0px_2px_4px_rgba(18,40,44,0.1)] mt-2">
                                    <input
                                        type="range"
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        value={+opacityValue}
                                        onChange={(e) => setOpacityValue(+e.target.value)}
                                    />
                                </div>
                            )}
                        </div>
                    </ContentViewer.Floating>

                    {/* <OverlayImageSlider
                        show={showImageSlider}
                        onClose={() => setShowImageSlider(false)}
                        images={images}
                        selectedImage={selectedImage}
                        onSelectedImageChange={onSelectedImageChange}
                        selectedDate={selectedDate}
                        onSelectedDateChange={onSelectedDateChange}
                        startDate={startDate}
                        endDate={endDate}
                        isLoading={isLoading}
                    /> */}
                </div>
            </ContentViewer>
        </>
    );
};

export default CameraBimViewer;
